module.exports = __webpack_public_path__ + "img/agenda-icon.3f0c2c1988edcede868326477b80fc33.svg";